export const PROFILE_VIEW_OPENED = 'uf.user.profile.opened';
export const ORGANIZATION_SETTINGS_PAGE_OPENED = 'uf.user.organization.opened';
export const FEATURE_DOCUMENTATION_OPENED =
  'uf.user.feature_documentation.opened';
export const RESILIENCE_INSIGHTS_HELP_OPENED =
  'uf.user.resilience_insights_help.opened';
